module.exports = __webpack_public_path__ + "img/155-ff59aa.png";